import { ServerError, ServerParseError, onError } from '../graphql';

type NetworkError = Parameters<
  Parameters<typeof onError>[0]
>[0]['networkError'];

export function isServerParseError(
  err: NetworkError | undefined | null
): err is ServerParseError {
  if (!err) {
    return false;
  }

  return 'name' in err && err.name === 'ServerParseError';
}

export function isServerError(
  err: NetworkError | undefined | null
): err is ServerError {
  if (!err) {
    return false;
  }

  return 'name' in err && err.name === 'ServerError';
}

export function isCloudflareChallengeError(
  err: NetworkError
): err is ServerParseError {
  if (!isServerParseError(err)) {
    return false;
  }

  if (err.statusCode !== 403) {
    return false;
  }

  return (
    err.bodyText.includes('captcha-bypass') ||
    err.bodyText.includes('keep DigitalOcean bot-free')
  );
}

export function isEdgePermissionDeniedError(
  err: NetworkError
): err is ServerParseError {
  return 'name' in err && err.name === 'PermissionDeniedError';
}
